import React, { ReactNode } from "react";
import { StyledRoundedContainer } from "./RoundedContainer.styled";
import { BodyTyp } from "../Typography/Typography";
import { FontWeightEnum } from "../../types/AppTypes";

type RoundedContainerProps = {
  children: React.JSX.Element | ReactNode;
  title?: string;
  padding?: number;
  fullHeight?: boolean;
};

export const RoundedContainer = ({
  children,
  title,
  padding,
  fullHeight,
}: RoundedContainerProps) => {
  return (
    <StyledRoundedContainer $padding={padding} $fullHeight={fullHeight}>
      {title && (
        <div className="rounded-container-title">
          <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
            {title}
          </BodyTyp>
        </div>
      )}
      {children}
    </StyledRoundedContainer>
  );
};
